var map = {
	"./BNB.svg": 14287,
	"./ETH.svg": 33728,
	"./angle-bottom.svg": 18460,
	"./angle-left.svg": 87654,
	"./angle-right.svg": 46693,
	"./back.svg": 79082,
	"./burn-icon.svg": 42230,
	"./calender.svg": 26973,
	"./copy-icon.svg": 29098,
	"./dolphin.svg": 86177,
	"./filter.svg": 87985,
	"./home-arrow-right.svg": 63115,
	"./instagram.svg": 85373,
	"./interest-filled-white.svg": 84682,
	"./interest-filled.svg": 29342,
	"./interest-pts.svg": 3449,
	"./interest-white.svg": 46041,
	"./interest.svg": 43749,
	"./like-filled-white.svg": 75051,
	"./like-filled.svg": 73883,
	"./like-white.svg": 17402,
	"./like.svg": 45998,
	"./m-footer.svg": 50784,
	"./mail.svg": 59814,
	"./medium.svg": 83926,
	"./menu.svg": 72434,
	"./net/BNB Smart Chain.svg": 73987,
	"./net/Cosmos.svg": 57523,
	"./net/Ethereum.svg": 4124,
	"./net/Harmony.svg": 85159,
	"./net/Kusama.svg": 28473,
	"./net/Minima.svg": 5152,
	"./net/Moonriver.svg": 77450,
	"./net/Near.svg": 63129,
	"./net/Polygon.svg": 86047,
	"./net/Solana.svg": 51759,
	"./post.svg": 3249,
	"./prawn.svg": 62981,
	"./question.svg": 64515,
	"./save-icon.svg": 1894,
	"./search.svg": 64343,
	"./share.svg": 67300,
	"./shark.svg": 26850,
	"./stake-icon.svg": 747,
	"./telegram-footer.svg": 93846,
	"./telegram.svg": 50830,
	"./time.svg": 97592,
	"./twitter.svg": 18592,
	"./user.svg": 10698,
	"./users.svg": 73557,
	"./wallet.svg": 56736,
	"./whale.svg": 64350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;